<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>车辆昵称：</label>
                <el-input v-model="search_Obj.f_display_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>车型：</label>
                <el-input v-model="search_Obj.f_car_type" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>CarId：</label>
                <el-input v-model="search_Obj.f_car_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>VehicleId：</label>
                <el-input v-model="search_Obj.f_vehicle_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="display_name" label="车辆昵称" sortable="custom"></el-table-column>
                <el-table-column prop="car_id" label="CarId" sortable="custom"></el-table-column>
                <el-table-column prop="vehicle_id" label="VehicleId" sortable="custom"></el-table-column>
                <el-table-column prop="car_type" label="车型" sortable="custom"></el-table-column>
                <el-table-column prop="banben" label="版本" sortable="custom"></el-table-column>
                <el-table-column prop="actual_delivered_date" label="提车时间" sortable="custom"></el-table-column>
                <el-table-column prop="create_time" label="入驻时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看车辆"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import { exportLocation } from "@/api/carinfo"

export default {
    name: 'carInfoList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '车辆',
            menu_id: 2200,
            list_url: "/api/admin/carinfo/list",
            search_Obj: {
                f_car_id: '',
                f_email: '',
                f_vehicle_id: '',
                f_display_name: '',
                f_car_type: '',
            },
            del_Obj:{
                url:'/api/admin/carinfo/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {
        exportLocation(){
            const loading = this.$loading({
                lock: true,
                text: '正在导出...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportLocation().then(res=>{
                loading.close()
                if(res.code ==1){
                    setTimeout(() => {
                        window.open(res.data+"")
                    }, 500);
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>